<div class="inner-page-header">
  <h3>
    {{ title }}
    <small class="font-12 font-regular">{{ titleDescription }}</small>
  </h3>
</div>
<div class="community-wrapper">
  <form class="needs-validation" id="general-form" [formGroup]="communityFormGroup">
    <div class="main-card">
      <div class="switch-wrapper">
        <app-switch-input [label]="'نشط'" [labelEn]="'is_active'" [labelDesc]="''" [value]="isActive"
          [customClass]="'justify-content-between'"
          (valueChanged)="communityFormGroup.get('is_active')?.setValue($event.value)">
        </app-switch-input>
      </div>

      <div class="form-group">
        <label for="" class="form-label">
          العنوان
          <span class="red">*</span>
        </label>
        <input type="text" class="form-control" formControlName="title" />
        <span class="form-text text-muted font-regular font-12">العنوان مطلوب.</span>
      </div>

      <div class="form-group">
        <label for="" class="form-label">الوصف</label>
        <textarea class="form-control" name="description" formControlName="description" maxlength="500"></textarea>
      </div>

      <div class="form-group">
        <label for="" class="form-label">
          الرمز
          <span class="red">*</span>
        </label>
        <input type="text" class="form-control" formControlName="code" />
      </div>

      <div class="form-group">
        <label for="" class="form-label">
          المشروع العقاري المرتبط
          <span class="red">*</span>
        </label>
        <ng-select #selectreproject bindLabel="name_ar" (scrollToEnd)="onScrollREProjectPagination()"
          class="single-select" formControlName="project" placeholder="يرجى اختيار المشروع" [searchable]="true"
          (removed)="resetREProjectSearch()" (search)="searchREProjectText()" (clear)="resetREProjectSearch()"
          (open)="resetREProjectSearch()" [virtualScroll]="true" [clearable]="true">
          @for (reProject of reProjects; track reProject) {
          <ng-option [value]="reProject.id">
            {{ reProject.name_ar }}
          </ng-option>
          }
        </ng-select>
      </div>

      <div class="invitation-links-wrapper">
        <div class="form-group link-item">
          <label for="" class="form-label">
            رابط نموذج الدعوة
            <span class="optional">(اختياري)</span>
          </label>
          <input type="text" class="form-control" formControlName="registration_form_link" />
          <span class="form-text text-muted font-regular font-12">رابط صالح — يجب أن يبدأ بـ //:https</span>
        </div>

        <div class="form-group link-item">
          <label for="" class="form-label">
            رابط نموذج الاستبيان
            <span class="optional">(اختياري)</span>
          </label>
          <input type="text" class="form-control" formControlName="survey_form_link" />
          <span class="form-text text-muted font-regular font-12">رابط صالح — يجب أن يبدأ بـ //:https</span>
        </div>

        <div class="form-group link-item">
          <label for="" class="form-label">
            عنوان الندوة
          </label>
          <input type="text" class="form-control" formControlName="webinar_title" />
          <span class="form-text text-muted font-regular font-12">يظهر في الدعوة وعلى صفحة الوصول.</span>
        </div>

        <div class="form-group link-item">
          <label for="" class="form-label">
            رابط ندوة الاجتماع
            <span class="optional">(اختياري)</span>
          </label>
          <input type="text" class="form-control" formControlName="webinar_link" />
          <span class="form-text text-muted font-regular font-12">يظهر في الدعوة وعلى صفحة الوصول.</span>
        </div>

        <div class="form-group link-item">
          <label for="" class="form-label">تاريخ إعتماد العقد</label>
          <mat-form-field (click)="picker.open()" appearance="outline">
            <input
              matInput
              formControlName="webinar_date"
              [matDatepicker]="picker"
              disabled
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
              <mat-icon matDatepickerToggleIcon class="calender-icon">
                <img src="assets/images/svg/calendar-admin-icon.svg" alt="" />
              </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="link-item">
          <app-time-picker 
            label="وقت الندوة (يلزم قبل المشاركة)" 
            formControlName="webinar_time">
          </app-time-picker>
        </div>

      </div>
      @if (errorMsg) {
        <div class="alert-box mt-3">
          <img
            src="assets/images/svg/error-icon.svg"
            class="close-alert"
            alt=""
          />
          <p class="alert-msg">{{ message }}</p>
        </div>
      }
    </div>

    <div class="double-action">
      <button type="button" class="btn btn-grey" (click)="goBack()">رجوع</button>
      <app-action-button (submitAction)="save($event)"></app-action-button>
    </div>
  </form>
</div>
